import { render, staticRenderFns } from "./altaTipoClinica.vue?vue&type=template&id=7f20eb6a"
import script from "./altaTipoClinica.vue?vue&type=script&lang=js"
export * from "./altaTipoClinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports